const formater = number => number.toLocaleString('en');
export default formater;
